// src/helpers/scroll-top.jsx
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ children, behavior = "auto" }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior }); // "auto" or "smooth"
  }, [pathname, hash, behavior]);

  return children ?? null;
}

ScrollToTop.propTypes = {
  children: PropTypes.node,
  behavior: PropTypes.oneOf(["auto", "smooth"])
};
